var map = {
	"./Logo_AKI_150.png": "fca9",
	"./Logo_JUKU_150.png": "c05c",
	"./Logo_KABU_150.png": "0b4a",
	"./Logo_SHIBU_150.png": "72d1",
	"./Logo_TCORP_150.png": "2bd9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a7ea";